import { c as _c } from "react/compiler-runtime";
import { useDialog } from '@/components/Molecules/Dialog/Dialog';
import type { ContactType } from '@/components/Organisms/ContactUs/ContactUs';
import { ContactUs } from '@/components/Organisms/ContactUs/ContactUs';
import { trackEvent } from '@/services/Analytics/BBAnalytics';
import { TrackingAction, TrackingCategory } from '@/services/Analytics/bnefAnalyticsSettings';
import classNames from '@/utils/classNames';
import type { HtmlHTMLAttributes } from 'react';
import type { FCh } from 'react-fc';
const trackBBEventContactUs = () => {
  return trackEvent(TrackingAction.Open, TrackingCategory.ContactForm);
};

/**
 * A button that looks like a link to open the contact us form.
 */
export const ContactFormLink: FCh<HtmlHTMLAttributes<HTMLButtonElement> & {
  contactType?: ContactType;
}> = t0 => {
  const $ = _c(20);
  let children;
  let className;
  let contactType;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      className,
      contactType,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = contactType;
    $[4] = rest;
  } else {
    children = $[1];
    className = $[2];
    contactType = $[3];
    rest = $[4];
  }
  const dialog = useDialog();
  let t1;
  if ($[5] !== className) {
    t1 = classNames(className, "cds-link");
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== dialog) {
    t2 = () => {
      trackBBEventContactUs();
      dialog.open();
    };
    $[7] = dialog;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== children || $[10] !== rest || $[11] !== t1 || $[12] !== t2) {
    t3 = <button className={t1} type="button" onClick={t2} {...rest}>{children}</button>;
    $[9] = children;
    $[10] = rest;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== contactType || $[15] !== dialog) {
    t4 = <ContactUs dialog={dialog} contactType={contactType} />;
    $[14] = contactType;
    $[15] = dialog;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== t3 || $[18] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};